
import { Vue, Component } from 'vue-property-decorator';
import { isWeiXin, getQueryString, WechatLogin } from '@/common/ts/common';
import SlideVerify from '@/components/next/SlideVerify.vue';
import { Field, Toast, Popup } from 'vant';
import { save } from '../api';
Vue.use(Field).use(Popup);
@Component({
  components: {
    SlideVerify,
  },
})
export default class Home extends Vue {
    question: string = '';
    showSlideVerify = false;
    isWeiXinCheck: any;
    created() {
        const getUnionid = window.localStorage.getItem('unionid');
        if (!getUnionid) {
        WechatLogin();
        }
    }
  onJumpToOutside() {
        location.href = 'https://activity.cqcb.com/shangyou_activity/2022h1/2022-lianghui-h5/home';
  }
    fSlideData(res: any) {
      this.showSlideVerify = false;
      if (isWeiXin()) {
      const data = {
        question: this.question,
        unionid: window.localStorage.getItem('unionid'),
        wxName: window.localStorage.getItem('nickname'),
        wxImg: window.localStorage.getItem('headimgurl'),
      };
      const lastData = Object.assign(res, data);
      save(lastData).then((result: any) =>
        this.successVote(result),
      );
    } else if (window.udid) {
      const data = {
        udid: window.udid,
        appkey: window.appkey,
        question: this.question,
      };
      const lastData = Object.assign(res, data);
      save(lastData).then((result: any) =>
        this.successVote(result),
      );
    }
    }
    successVote(res: any) {
    switch (res.code) {
      case 200:
        Toast({
          type: 'success',
          duration: 1200,
          message: res.msg,
        });
        setTimeout(() => {
            location. reload();
        }, 3000);
        break;
      case 201:
        // 需要滑动验证
        this.showSlideVerify = true;
        break;
      case 203:
        if (parseFloat(window.version) >= 4.5) {
          // 需要在App内登录
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          // 老版本唤起App登录页面栈
          window.location.href = 'client:logout';
        }
        break;
      case 500:
      case 204:
      case 300:
      case 101:
        Toast.fail(res.msg);
        break;
    }
  }
    sub() {
    if ( this.question === '' ) {
      Toast('问题不能为空');
      return false;
    }  else {
        this.submitPerson();
      }
    }
    async submitPerson() {
    if (isWeiXin() && !window.localStorage.getItem('unionid')) {
      this.$dialog
        .confirm({
          title: '微信登录',
          message: '提问前需要进行微信登录',
        })
        .then(() => {
          console.log('确定');
          WechatLogin();
        })
        .catch(() => {
          console.log('取消');
        });
      return;
    }
    if (isWeiXin()) {
        this.isWeiXinCheck = 1;
        console.log('开始提交');
        const data = {
            question: this.question,
            unionid: window.localStorage.getItem('unionid'),
            wxName: window.localStorage.getItem('nickname'),
            wxImg: window.localStorage.getItem('headimgurl'),
        };
        const saveRes: any = await save(data);
        if (saveRes.code === 200) {
            Toast.success({duration: 3000, message: saveRes.msg});
            setTimeout(() => {
            location. reload();
            }, 3000);
        } else if (saveRes.code === 201) {
            this.showSlideVerify = true;
        } else {
            Toast.fail(saveRes.msg);
        }
    } else {
        this.isWeiXinCheck = 0;
        const data = {
            question: this.question,
            udid: window.udid,
            appkey: window.appkey,
        };
        const saveRes: any = await save(data);
        if (saveRes.code === 200) {
            Toast.success({duration: 3000, message: saveRes.msg});
            setTimeout(() => {
            location. reload();
            }, 3000);
        } else if (saveRes.code === 201) {
            this.showSlideVerify = true;
        } else if (saveRes.code === 203) {
            if (parseFloat(window.version) >= 4.5) {
                window.handleMessage('{"action":"mUserLogin","data":""}');
            } else {
                window.location.href = 'client:logout';
            }
        } else {
            Toast.fail(saveRes.msg);
        }
    }
    // check.start();
  }
}
